import { ExportToCsv } from 'export-to-csv';
export const createExportToCsvFactory = (options) => {
    const { defaultCsvOptions, } = options;
    const createExportToCsv = (csvOptionOverrides) => {
        var _a;
        const defaultFilename = (_a = csvOptionOverrides === null || csvOptionOverrides === void 0 ? void 0 : csvOptionOverrides.title) !== null && _a !== void 0 ? _a : defaultCsvOptions.filename;
        const csvOptions = Object.assign(Object.assign(Object.assign({}, defaultCsvOptions), { filename: defaultFilename }), csvOptionOverrides);
        return new ExportToCsv(csvOptions);
    };
    return createExportToCsv;
};
//# sourceMappingURL=createExportToCsv.js.map